<template>
  <a-space style="flex-wrap: wrap;margin-top: 4px">
    <AuthMallSelect v-if="false" @getSuccess="getMallSuccess" ></AuthMallSelect>
    <a-cascader
      popupClassName="taote-category-cascader-popup"
      style="width: 210px;"
      v-model:value="currentItem.params.catId"
      :options="currentItem.categoryList"
      expand-trigger="click"
      placeholder="请选择 1 个类目"
      :load-data="loadCategoryData"
      :changeOnSelect="true"
      @change="searchGoods"
    />
    <a-input
      v-model:value="currentItem.params.keyword"
      placeholder="请输入关键字"
      allowClear
      @keydown.enter="searchGoods"
    />
    <a-button type="primary" class="search-btn" @click="searchGoods">
      <SearchOutlined />搜索
    </a-button>
    <a-radio-group
      button-style="solid"
      v-model:value="currentItem.params.poolId"
      @change="searchGoods"
    >
      <a-tooltip
        v-for="item in currentItem.typeOptions"
        :key="item.value"
        placement="top"
        overlayClassName="goods-name-popover"
      >
        <template #title>
          {{ item.tip }}
        </template>
        <a-radio-button :value="item.value">
          <!-- <div class="jx-price-tag" v-show="item.showJxTag">
            专享价
          </div> -->
          {{ item.label }}
        </a-radio-button>
      </a-tooltip>
    </a-radio-group>
  </a-space>
  <Filter ref="filter" @change-filter="changeFilter" />
</template>
<script>
  import { SearchOutlined } from "@ant-design/icons-vue"
  import { LoadCategoryData } from '../../utils'
  import Filter from '../1688_goods_filter'
  import AuthMallSelect from '@/views/base/components/auth_mall_select'
  export default {
    components: { SearchOutlined, Filter, AuthMallSelect},
    data() {
      return {
        currentItem: {
          params: {},
          categoryList: [],
          typeOptions: []
        }
      }
    },
    props: {
      params: {
        type: Object,
        default: () => ({})
      }
    },
    emits: ['searchGoods','getMallSuccess'],
    methods: {
      searchGoods() {
        this.$emit('searchGoods')
      },
      loadCategoryData(selectedOptions) {
        LoadCategoryData(this,selectedOptions)
      },
      getMallSuccess(bool) {
        this.currentItem.params.aliProductFilterParams = {
          ...this.$refs.filter.params,
        };
        this.$emit("getMallSuccess", bool);
      },
      changeFilter(data) {
        this.currentItem.params.filters = data
        this.searchGoods()
      }
    },
    watch: {
      'params.value': {
        handler() {
          this.currentItem = this.params
        },
        immediate: true
      }
    }
  }
</script>